import type { SetState } from "zustand";

import type { AskPerformYardState } from "../types";

export const createUiSlice = (set: SetState<AskPerformYardState>) => ({
	isOpen: false,
	isExpanded: false,
	forceHidden: false,

	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false }),
	toggleExpand: () => set((state) => ({ isExpanded: !state.isExpanded })),
	setInputValue: (value: string) => set({ inputValue: value }),
	setForceHidden: (hidden: boolean) => set({ forceHidden: hidden }),
});
